// extracted by mini-css-extract-plugin
module.exports = {"gray":"DisplaySection_gray__zuDVk","white":"DisplaySection_white__0jTNU","borders":"DisplaySection_borders__2B63h"};